import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "api",
  "use": "api-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"api\"><path d=\"M0 0h4v14H0zM5 0h9v2H5zM5 4h9v2H5zM5 8h9v2H5zM5 12h9v2H5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id